import React, { useState } from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { routerStore } from 'core/routing';

import { conf } from 'apps/repository/config.yaml';
import { Card, Title, OpName } from 'apps/repository/contributionPage/styles';

import { FilePreviewer } from 'libs/rendering/preview';

import { StyledLink } from 'legacyComponents/styled/lib';
import { withConditional } from 'legacyComponents/hoc/conditional';

const OldPath = withConditional(styled.span``);

export const OpCard = observer(({ operation, contribution }) => {
  // TODO: Add Previews, download button?
  const { router } = routerStore;
  const { oldPath, path, opType } = operation;
  const displayOp = opType.endsWith('E') ? `${opType}D` : `${opType}ED`;

  const fileParams = { ...contribution.route.params, basepath: operation.path };

  const viewerRouteName = `${contribution.project.route.name}.version.file`;
  const viewerPath = router.buildUrl(viewerRouteName, fileParams);
  const [minimised, updateMinimised] = useState(true);

  return (
    <Card id={operation.domId}>
      <Title onClick={() => updateMinimised(!minimised)}>
        {minimised ? '\u02C3' : '\u02C5'}
        <StyledLink name={viewerRouteName} params={fileParams}>
          <OldPath condition={!!oldPath}>{oldPath}</OldPath> {path}
        </StyledLink>
      </Title>
      {minimised || (
        <FilePreviewer
          viewerURL={`${MAIN_URL}${viewerPath}`}
          allowViewer
        ></FilePreviewer>
      )}
      <OpName color={conf.operationColors[opType]}>{displayOp}</OpName>
    </Card>
  );
});

OpCard.propTypes = {
  operation: PropTypes.object,
};
